import React, { useEffect, useState, useCallback } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { fetchTrafficSources } from '../../api/analyticsApi';
import { FormControl, MenuItem, Select } from '@mui/material';
import { Globe, Search, Link2, Share2, Mail, HelpCircle } from 'lucide-react';

const TrafficSources = () => {
  const [sources, setSources] = useState([]);
  const [period, setPeriod] = useState('7d');

  const loadSources = useCallback(async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const data = await fetchTrafficSources(user?.propertyId?.id, period);
    setSources(data);
  }, [period]);

  useEffect(() => {
    loadSources();
    const interval = setInterval(loadSources, 10000);
    return () => clearInterval(interval);
  }, [period, loadSources]);

  const getIcon = (medium) => {
    switch (medium) {
      case 'Direct': return <Globe size={16} />;
      case 'Organic Search': return <Search size={16} />;
      case 'Referral': return <Link2 size={16} />;
      case 'Social': return <Share2 size={16} />;
      case 'Email': return <Mail size={16} />;
      default: return <HelpCircle size={16} />;
    }
  };

  return (
    <Box bgcolor="white" p={2} borderRadius={2} boxShadow={1} minHeight={390}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle2" color="textSecondary">TRAFFIC SOURCES</Typography>
        <FormControl size="small">
          <Select
            value={period}
            onChange={(e) => setPeriod(e.target.value)}
            variant="standard"
            disableUnderline
          >
            <MenuItem value="7d">Last 7 days</MenuItem>
            <MenuItem value="30d">Last 30 days</MenuItem>
            <MenuItem value="60d">Last 60 days</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Stack spacing={1.2}>
        {sources.map((source, idx) => {
          const percent = source.percentChange ?? 0;
          const direction = percent > 0 ? '▲' : percent < 0 ? '▼' : '';
          const color = percent > 0 ? 'green' : percent < 0 ? 'red' : 'gray';
          return (
            <Box key={idx}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" alignItems="center" gap={1}>
                  {getIcon(source.medium)}
                  <Typography noWrap fontSize="0.95rem">{source.medium}</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography fontWeight="normal" fontSize="0.9rem">{source.count}</Typography>
                  <Typography variant="caption" color={color}>
                    {direction} {Math.abs(percent)}%
                  </Typography>
                </Box>
              </Box>
              <Box
                height={6}
                mt={0.3}
                borderRadius={5}
                bgcolor="#eee"
                position="relative"
              >
                <Box
                  bgcolor="#1976d2"
                  height="100%"
                  width={`${(source.count / (sources[0]?.count || 1)) * 100}%`}
                  borderRadius={5}
                  sx={{
                    transition: 'width 0.6s ease-in-out'
                  }}
                />
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};

export default TrafficSources;
